<app-info-message *ngIf="!tableData.data?.length" [message]="'general.api_reports_table_no_results'"></app-info-message>
<table class="report-table manual-alternating-color bottom-spacer" *ngIf="tableData.data?.length && tableConfig?.body?.length">
  <thead *ngIf="tableConfig.headers?.length">
    <tr>
      <ng-container *ngFor="let header of tableConfig.headers; let first = first">
        <th class="break-word" [ngClass]="header.customClass"
            *ngIf="!utilService.isMobile || !tableConfig.internalArrayKey || !first">
          {{ header.title | translate }}
          <ng-container *ngIf="header.symbol">&nbsp;({{ header.symbol === 'price' ? authService.currencySymbol : 'pcs' }})</ng-container>
          <mat-icon class="svg-icon text-grey" *ngIf="header.tooltip?.length" [svgIcon]="'info'" [matTooltip]="header.tooltip | translate"></mat-icon>
          <span class="subtitle" *ngIf="header.subTitle?.length">{{ header.subTitle | translate }}</span>
        </th>
      </ng-container>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let item of tableData.data; let even = even; let first = first">
      <ng-container *ngIf="tableConfig.internalArrayKey?.length">
        <tr [ngClass]="{'alternate' : even}" *ngIf="utilService.isMobile && item[tableConfig.internalArrayKey]?.length">
          <ng-container [ngTemplateOutlet]="columnTemplate" [ngTemplateOutletContext]="{item: item, parent: item, spanFields: true}"></ng-container>
        </tr>
        <tr [ngClass]="{'alternate' : even}" *ngFor="let internalItem of item[tableConfig.internalArrayKey]; let internalFirst = first">
          <ng-container [ngTemplateOutlet]="columnTemplate"
                        [ngTemplateOutletContext]="{item: internalItem, parent: item, first: internalFirst}"></ng-container>
        </tr>
      </ng-container>
      <tr [ngClass]="{'alternate' : even}" *ngIf="!tableConfig.internalArrayKey?.length">
        <ng-container [ngTemplateOutlet]="columnTemplate" [ngTemplateOutletContext]="{item: item, first: first}"></ng-container>
      </tr>
    </ng-container>
  </tbody>
  <tfoot *ngIf="tableData.total">
    <tr>
      <th *ngFor="let total of tableConfig.totals"
          [ngClass]="{'white-space-no-wrap align-right': ['price', 'percentage'].includes(total.valueType)}"
          [colSpan]="total.colSpan ? (utilService.isMobile ? (total.colSpan - 1) : total.colSpan) : 1">
        <ng-container *ngIf="total.title?.length">{{ total.title | translate }}</ng-container>
        <ng-container *ngIf="total.key?.length" [ngTemplateOutlet]="valueTemplate"
                      [ngTemplateOutletContext]="{selectedItem: {value: tableData.total[total.key], type: total.valueType}, hideSymbol: total.hideSymbol, translationKey: total.translationKey}"></ng-container>
      </th>
    </tr>
  </tfoot>
</table>
<ng-template #columnTemplate let-item="item" let-parent="parent" let-first="first" let-spanFields="spanFields">
  <ng-container *ngFor="let tableItem of tableConfig.body; let firstItem = first">
    <td *ngIf="spanFields && firstItem" [colSpan]="spanFields ? (tableConfig.headers?.length - 1) : 1">
      <span class="bold">{{ tableConfig.headers[0].title | translate }}:&nbsp;</span>
      <span [ngClass]="{'title': tableItem.subItem}">
        <ng-container [ngTemplateOutlet]="keySelectTemplate" [ngTemplateOutletContext]="{item: (tableItem.useParent && parent) ? parent : item, tableItem: tableItem}"></ng-container>
      </span>
      <ng-container *ngIf="tableItem.subItem">
        <br>
        <span class="medium">{{ tableConfig.headers[0].subTitle | translate }}:&nbsp;</span>
        <ng-container [ngTemplateOutlet]="keySelectTemplate" [ngTemplateOutletContext]="{item: (tableItem.useParent && parent) ? parent : item, tableItem: tableItem.subItem}"></ng-container>
      </ng-container>
    </td>
    <td *ngIf="!spanFields && (!tableItem.useRowSpan || (tableItem.useRowSpan && first && !utilService.isMobile))"
        [ngClass]="{'white-space-no-wrap align-right': ['price', 'percentage'].includes(tableItem.valueType)}"
        [rowSpan]="(tableItem.useRowSpan && parent) ? parent[tableConfig.internalArrayKey].length : 1">
      <span [ngClass]="{'title': tableItem.subItem}">
        <ng-container [ngTemplateOutlet]="keySelectTemplate" [ngTemplateOutletContext]="{item: (tableItem.useParent && parent) ? parent : item, tableItem: tableItem}"></ng-container>
      </span>
      <ng-container *ngIf="tableItem.subItem">
        <br><ng-container [ngTemplateOutlet]="keySelectTemplate" [ngTemplateOutletContext]="{item: (tableItem.useParent && parent) ? parent : item, tableItem: tableItem.subItem}"></ng-container>
      </ng-container>
    </td>
  </ng-container>
</ng-template>
<ng-template #keySelectTemplate let-item="item" let-tableItem="tableItem">
  <ng-container [ngTemplateOutlet]="valueTemplate"
                [ngTemplateOutletContext]="{selectedItem: selectProperItem(item, tableItem), hideSymbol: tableItem.hideSymbol, translationKey: tableItem.translationKey}"></ng-container>
</ng-template>
<ng-template #valueTemplate let-selectedItem="selectedItem" let-hideSymbol="hideSymbol" let-translationKey="translationKey">
  <ng-container *ngIf="!selectedItem.type || selectedItem.type === 'text'">{{ selectedItem.value | translateValue }}</ng-container>
  <ng-container *ngIf="selectedItem.type === 'simple'">{{ selectedItem.value }}</ng-container>
  <ng-container *ngIf="selectedItem.type === 'price'">{{ selectedItem.value | price: hideSymbol }}</ng-container>
  <ng-container *ngIf="selectedItem.type === 'percentage'">{{ selectedItem.value + (hideSymbol ? '' : '%') }}</ng-container>
  <ng-container *ngIf="selectedItem.type === 'date'">{{ selectedItem.value | moment: { format: viewService.conf.timeFormat, tz: tableConfig.timezone } }}</ng-container>
  <ng-container *ngIf="selectedItem.type === 'period'">{{ selectedItem.value | period: {hasTimeInPeriod: true, threeDotsIfEmpty: true} }}</ng-container>
  <ng-container *ngIf="selectedItem.type === 'translation'">{{ (translationKey + (selectedItem.value | lowercase)) | translate }}</ng-container>
</ng-template>
